import React, { useCallback, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import drag from "../../../assets/images/icons/drag.png";
import man2 from "../../../assets/images/icons/profile.png";
import edit from "../../../assets/images/icons/edit.png";
import open_eye from "../../../assets/images/icons/open-eye.png";
import clock from "../../../assets/images/icons/clock.png";
import { filter_icon } from '../../../assets/images';
import { SEARCH_QUOTATION_BLANK } from '../../../store/Sales/actiontype';
import { QUOTATION_RESULT_SELECTED_BLANK } from '../../../store/InstantRate/actionType';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TransferDialog from '../Quotations/Dialog/TransferDialog';
import { postTransferStatusData } from '../../../store/Sales/actions';
import { useDispatch } from 'react-redux';
import {
  customerReject,
  draft,
  MAIL_SENT,
  MGR_APPRV_PENDING,
  MANAGER_APPRVD,
  QUOTATION_EDITED,
  VERIFIED,
  BID_ACCEPTED,
  customerApproved
} from '../../Dashboard/Partials/initialData';
import {formatModifyDate, getInternalRoute, useMobileView} from "../../../components/Common/CommonLogic";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {QUOTE_MODAL_INITIAL} from "../../../store/Sales/Quotation/actiontype";
import {hasInstantPermission} from "../../../common/data/ApplicationModules";

const QueriesCompDemo = ({ QuoteModalHandler, previewModalHand, toggleRightCanvas }) => {
  const isAllowedDrage = [draft, VERIFIED, QUOTATION_EDITED, MAIL_SENT, MGR_APPRV_PENDING, MANAGER_APPRVD];
  const { fcl_summary_data } = useSelector((state) => state?.quotation);
  const [reason, setReason] = useState();
  const { is_transfer_status_loader, inquiry_transfer_status_data_loader } = useSelector((state) => state?.sales);
  const { status_master } = useSelector((state) => state.globalReducer);
  const [modal, setmodal] = useState(false);
  const dispatch = useDispatch();
  const [items, setItems] = useState({});
  const [isOpenTransferDialog, setIsOpenTransferDialog] = useState(false);
  const [dragDestination, setDragDestination] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const navigate = useNavigate();
  const isMobile = useMobileView();

  const cleanupDragData = useCallback(() => {
    setIsOpenTransferDialog(false);
    setDraggedItem(null);
    setDragDestination(null)
  }, [])

  const onDragStart = (start) => {
    const { source } = start;
    const item = items[source.droppableId][source.index];
    if (isAllowedDrage.includes(item.statusCode)) {
      setDraggedItem({ ...item, index: source.index, droppableId: source.droppableId });
    }
  };

  const onDragEnd = (result) => {
    const { destination } = result;

    if (!destination || !draggedItem) return;

    setDragDestination(destination);
    setIsOpenTransferDialog(true);
  };



  useEffect(() => {
    setItems(fcl_summary_data)
  }, [fcl_summary_data])


  useEffect(() => {
    cleanupDragData();
  }, [inquiry_transfer_status_data_loader,fcl_summary_data])



  const handleTransferConfirm = async () => {
    //console.log(dragDestination, "dragDestination");
    //console.log(draggedItem, "draggedItem");
    let url = `?summeryId=${draggedItem?.id}&statusId=${status_master?.find((item) => item?.statusCode === dragDestination?.droppableId)?.id}&reasonId=${reason?.id ? reason?.id : 0}`;
    dispatch(postTransferStatusData(url));
    setReason({})
  };




  const calculatePercentage = (listType) => {
    const list1Length = items?.[draft]?.length || 0;
    const list2Length = items?.[customerReject]?.length || 0;
    const list3Length = items?.[customerApproved]?.length || 0;

    const totalLength = list1Length + list2Length + list3Length;

    if (totalLength > 0) {
      if (listType === draft) {
        return Math.round((list1Length / totalLength) * 100);
      } else if (listType === customerReject) {
        return Math.round((list2Length / totalLength) * 100);
      } else if (listType === customerApproved) {
        return Math.round((list3Length / totalLength) * 100);
      }
    }

    return 0;
  };


  const percentageForList1 = calculatePercentage(draft);
  const percentageForList2 = calculatePercentage(customerReject);
  const percentageForList3 = calculatePercentage(customerApproved);


  const remainingPercentage1 = 100 - percentageForList1;
  const remainingPercentage2 = 100 - percentageForList2;
  const remainingPercentage3 = 100 - percentageForList3;

  const createQuotations = () => {
    dispatch({ type: QUOTE_MODAL_INITIAL });
    dispatch({ type: SEARCH_QUOTATION_BLANK });
    dispatch({ type: QUOTATION_RESULT_SELECTED_BLANK });
    navigate(getInternalRoute("instant-search-rate"));
  }
  const [btnprimary1, setBtnprimary1] = useState(false);
  return (
    <>
      <div className=" mb-5">
        <div className=" freight_filter_wrap d-flex align-items-center">
          <div className="label flex-grow-1 ">
          </div>
          <div className="right_actions_wrap flex-shrink-0 d-flex align-items-center">
            <div className="search_form">
              <form>
                <div className="position-relative">
                  <input type="search" className="form-control" placeholder="Search" value="" />
                  <button className="btn" type="button"><i className="bx bx-search-alt-2 align-middle"></i></button>
                </div>
              </form>
            </div>
            <div className="filter_wrap">
              <button className="bg-transparent">
                <img src={filter_icon} onClick={toggleRightCanvas} alt="filter" /></button></div><div className="upload_wrap">
            </div>
            {/*className="add_btn"*/}
            <div>
              <Dropdown isOpen={btnprimary1} toggle={() => setBtnprimary1(!btnprimary1)}>
                <DropdownToggle tag="button" className="btn btn-primary">
                  <i className="mdi mdi-chevron-down" /> Create
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end" style={{backgroundColor: "#fff"}}>
                  <DropdownItem onClick={() => {
                    dispatch({ type: QUOTE_MODAL_INITIAL });
                    navigate("/create/smart/quotation");
                  }}><i className="bx bx-plus align-middle"></i> Smart Quotations</DropdownItem>
                  <DropdownItem disabled={!hasInstantPermission() ? true : false} onClick={() => createQuotations() }><i className="bx bx-plus align-middle"></i> Instant Rate Search</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {/*<button className="border-0" onClick={() => { createQuotations()  }}><i className="bx bx-plus align-middle"></i> Create</button>*/}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between mobScreen">
          <div className="quotationcard mb-4 innerbox2">
            <div className="d-flex align-items-center circlebox">
              <div className="circle-container">
                <div className="circle percentage-60">
                  {/* <span>{items?.DRAFT?.length > 0 ? Math.round((items?.DRAFT?.length / (items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)) * 100) : 0} %</span>
                  <div className="percentage-bar"></div> */}
                  <span>{percentageForList1} %</span>
                  <div className="percentage-bar" style={{ clipPath: `inset(0 0 0 ${remainingPercentage1}%)` }}></div>
                </div>
              </div>
              <h3 className="mb-0 ms-4">
                In Progress <span className="fw-400">({items?.DRAFT?.length}/{(items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)})</span>
              </h3>
            </div>
          </div>

          <div className="quotationcard mb-4 innerbox2">
            <div className="d-flex align-items-center circlebox">
              <div className="circle1-container">
                <div className="circle1 percentage-40">
                  {/* <span>{items?.CUST_REJECT?.length ? Math.round((items?.CUST_REJECT?.length / (items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)) * 100) : 0} %</span>
                  <div className="percentage-bar"></div> */}
                  <span>{percentageForList2} %</span>
                  <div className="percentage-bar" style={{ clipPath: `inset(0 0 0 ${remainingPercentage2}%)` }}></div>
                </div>
              </div>
              <h3 className="mb-0 ms-4">
                Lost <span className="fw-400">({items?.CUST_REJECT?.length}/{(items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)})</span>
              </h3>
            </div>
          </div>

          <div className="quotationcard mb-4 innerbox2"
          >
            <div className="d-flex align-items-center circlebox">
              <div className="circle2-container">
                <div className="circle2 percentage-60">
                  {/* <span>{items?.CUST_APPRVD?.length ? Math.round((items?.CUST_APPRVD?.length / (items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)) * 100) : 0} %</span>
                  <div className="percentage-bar"></div> */}
                  <span>{percentageForList3} %</span>
                  <div className="percentage-bar" style={{ clipPath: `inset(0 0 0 ${remainingPercentage3}%)` }}></div>
                </div>
              </div>
              <h3 className="mb-0 ms-4">
                Won <span className="fw-400">({items?.CUST_APPRVD?.length}/{(items?.DRAFT?.length + items?.CUST_REJECT?.length + items?.CUST_APPRVD?.length)})</span>
              </h3>
            </div>
          </div>
        </div>
        {console.log(items, "items")}
        <DragDropContext
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}>
          <div className={isMobile ? 'col' : 'row'}>
            {Object.keys(items).map((listKey) => (
              <Droppable droppableId={listKey} key={listKey}>
                {(provided) => (
                  <div
                    className={isMobile ? 'mt-4 col d-flex dragdrop_content' : 'mt-0 col-4 d-flex dragdrop_content'}
                    {...provided.droppableProps}
                    ref={provided.innerRef}>
                    <div className="w-100 colBoxMain">
                      <div className="mainCol w-100">
                        {items[listKey].map((item, index) => (
                          <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                            {(provided) => (
                              <div
                                className="colBox"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div className="card w-100 h-100">
                                  <div className="card-header d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                      <img src={drag} alt="profile" className="profile1" />
                                      <p className="mb-0 rounded px-2 py-1 custom-text text-primary text-nowrap">
                                        {item.sequenceId}
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <p className="mb-0">{formatModifyDate(item?.inquiryDate)}</p>
                                    </div>
                                  </div>
                                  <div className='p-2'>
                                    <div className="d-flex justify-content-between">
                                      <ul className="list-unstyled method1">
                                        <li>Quotation Id</li>
                                        <li>Customer</li>
                                        <li>Status</li>
                                        <li>Origin Port</li>
                                        <li>Destination Port</li>
                                        <li>Version</li>
                                        <li>Last Update</li>
                                      </ul>
                                      <ul className="list-unstyled text-end method2">
                                        <li>{item?.id}</li>
                                        <li>{item?.isMarketPlace === true ? item?.shipperTenantName : item?.customerName || '-'}</li>
                                        <li>{item?.statusName}</li>
                                        <li>{item?.originPortName || "-"}</li>
                                        <li>{item?.destinationPortName || "-"}</li>
                                        <li>{item?.version}</li>
                                        <li>{formatModifyDate(item?.lastUpdatedDate)} </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="card-footer p-1 pt-2 d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                      <img src={man2} alt="profile" className="profile" />
                                      <p className="mb-0">{item?.salesUserName}</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      {/*{item.statusCode !== MAIL_SENT && item.statusCode !== draft && item?.statusCode !==customerReject && <span onClick={() => QuoteModalHandler('mail', item)}><i className="mdi mdi-email-outline mdi-24px me-1"></i></span>}*/}
                                      <img src={clock} alt="profile" onClick={() => QuoteModalHandler('history', item)} className="profile1" />
                                      <img src={open_eye} onClick={() => QuoteModalHandler('pdf', item)} alt="profile" className="profile1" />
                                      {isAllowedDrage.includes(item.statusCode) && <img src={edit} onClick={() => QuoteModalHandler('edit', item)} alt="profile" className="profile1" />}

                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                      {provided.placeholder}
                    </div>
                  </div>
                )}
              </Droppable>
            ))}
          </div>
        </DragDropContext>
      </div>
      <TransferDialog
        isOpen={isOpenTransferDialog}
        onClose={cleanupDragData}
        onConfirm={handleTransferConfirm}
        loading={is_transfer_status_loader}
        data={draggedItem?.sequenceId}
        setReason={setReason}
        message={dragDestination?.droppableId === customerReject ? "Lost" : dragDestination?.droppableId === BID_ACCEPTED ? "Won" : ""}
      />
    </>
  )
}
export default QueriesCompDemo;
